import { TadaAyanaAPI } from ".";

export default {
  postLogin(email, password) {
    return TadaAyanaAPI.post("/login", { username: email, password: password });
  }
};
